const statusList = [
  { value: 0, name: '發電中' },
  { value: 1, name: '建置中' },
  { value: 2, name: '維修中' }
];

export default statusList;
